<template>
	<div>
		<ul v-if="currentFilters.length > 0">
			<li v-for="filter in currentFilters" :key="filter.id" class="filter" @click="setProviderDefault">
				<router-link :to="'/filter/' + filter.id" >
					<i :class="['el-icon-arrow-right expand-icon']"></i> {{ filter.name }}
				</router-link>
			</li>
		</ul>
		<span v-else class="no-filter">
			No Filters
		</span>
	</div>
	
</template>
<script>
import { mapState } from 'vuex'
import SidebarList from '.'

export default {
	name: 'sidebar-filter-list',
	props: {
		id: {
			type: String
		}
	},
	extends: SidebarList,

	methods: {
		setProviderDefault() {
			try {
				if(this.getProviderList.length === 1 && !this.getCurrentProvider)
					this.setCurrentProvider(this.getProviderList[0].provider)
				else if(this.id)
					this.setCurrentProvider(this.id)
			} catch (error) {
				console.error('Could not setprovider', error)
			}
		}
	},

	computed: {
		...mapState('provider', [
			'filters'
		]),
		currentFilters() {
			if(this.id)
				return this.filters[this.id] || []
			else if(this.getProviderList.length == 1)
				return Object.values(this.filters).flat()
			return []
		}
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
li > a.router-link-exact-active {
	background-color: #3572b9;
	color: #ffffff;
}
.filter a {
	padding-left: 10px;
}
</style>
